import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/home/index'
import MapAlarm from '@/pages/map/map'
import AlarmList from '@/pages/alarm/list'
import List from '@/pages/system/list'
import Maintenance from '@/pages/maintenance/list'
import Contract from '@/pages/contract/list'
import Statistics from '@/pages/statisticsList/list'

import SystemIndex from '@/pages/system/index'

import Manage from '@/pages/system/manage'
import RoleMgt from '@/pages/system/role'
import AreaMgt from '@/pages/system/area'
import TimeMgt from '@/pages/system/time'
import CustomerMgt from '@/pages/system/customer'
import EquipmentMgt from '@/pages/system/equipment'
import DictionaryMgt from '@/pages/system/dictionary'

import workLoad from '@/pages/statisticsList/workLoad'
import processTime from '@/pages/statisticsList/processTime'
import alarmTime from '@/pages/statisticsList/alarmTime'
import alarmFrequency from '@/pages/statisticsList/alarmFrequency'

//鸿瑞首页
import Login from '@/pages/login/login'
//毅知首页
//import Login from '@/pages/login/loginYz'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*', //当url不存在 自动跳转到focus
      redirect: '/login'
    }, {
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [{
          path: '/static/map',
          name: 'mapAlarm',
          component: MapAlarm
        },
        {
          path: '/static/alarmList',
          name: 'alarmList',
          component: AlarmList
        }, {
          path: '/static/maintenance',
          name: 'Maintenance',
          component: Maintenance
        }, {
          path: '/static/contract',
          name: 'Contract',
          component: Contract
        },
		
		  // {
		  //   path: '/static/workLoad',
		  //   name: 'workLoad',
		  //   component: workLoad
		  // },
		  // {
		  //   path: '/static/processTime',
		  //   name: 'processTime',
		  //   component: processTime
		  // },
		  // {
		  //   path: '/static/alarmTime',
		  //   name: 'alarmTime',
		  //   component: alarmTime
		  // },
		  // {
		  //   path: '/static/alarmFrequency',
		  //   name: 'alarmFrequency',
		  //   component: alarmFrequency
		  // },
		
		{
          path: '/static/statistics',
          name: 'Statistics',
          component: Statistics,
          children:[
            {
              path: '/static/statisticsList/workLoad',
              name: 'workLoad',
              component: workLoad
            },
            {
              path: '/static/statisticsList/processTime',
              name: 'processTime',
              component: processTime
            },
            {
              path: '/static/statisticsList/alarmTime',
              name: 'alarmTime',
              component: alarmTime
            },
            {
              path: '/static/statisticsList/alarmFrequency',
              name: 'alarmFrequency',
              component: alarmFrequency
            },
          ],
        }, {
          path: '/static/list',
          name: 'List',
          component: List,
          children:[
            {
              path: '/static/system/manage',
              name: 'manage',
              component: Manage
            },
            {
              path: '/static/system/role',
              name: 'role',
              component: RoleMgt
            },
            {
              path: '/static/system/area',
              name: 'area',
              component: AreaMgt
            },
            {
              path: '/static/system/time',
              name: 'time',
              component: TimeMgt
            },
            {
              path: '/static/system/customer',
              name: 'customer',
              component: CustomerMgt
            },
            {
              path: '/static/system/equipment',
              name: 'equipment',
              component: EquipmentMgt
            },
            {
              path: '/static/system/dictionary',
              name: 'dictionary',
              component: DictionaryMgt
            },
          ],

        }
      ]
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js